'use client';

import Image from '@/components/Image';

interface HomeworkWelcomeProps {
  homeworkInfo: {
    topicName?: string;
    coverUrl?: string | null;
  };
  onContinue: () => void;
}

export default function HomeworkWelcome({
  homeworkInfo,
  onContinue,
}: HomeworkWelcomeProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        {/* Card */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          {/* Logo with Powered by - Above cover image */}
          <div className="flex flex-col items-center gap-3 py-6 px-8 bg-white">
            <Image
              src="/assets/logo-flow-quiz-2.png"
              alt="FlowQuiz"
              width={180}
              height={50}
              className="h-12 w-auto"
              priority
            />
            <p className="text-base font-semibold text-gray-600">
              Powered by Pengi.ai
            </p>
          </div>

          {/* Cover Image */}
          <div className="relative h-56 bg-gradient-to-br from-purple-600 to-blue-500 overflow-hidden">
            {homeworkInfo.coverUrl ? (
              <Image
                src={homeworkInfo.coverUrl}
                alt={homeworkInfo.topicName || 'Homework'}
                width={400}
                height={224}
                className="w-full h-full object-cover"
                priority
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-white">
                <svg className="w-24 h-24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
                </svg>
              </div>
            )}
          </div>

          {/* Content */}
          <div className="p-8">
            {/* Message */}
            <p className="text-center text-gray-600 mb-6 leading-relaxed">
              This homework will open in <span className="font-bold text-purple-600">Pengi.ai</span> where you can complete the assignment.
            </p>

            {/* Continue Button */}
            <button
              onClick={onContinue}
              className="w-full py-4 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all"
              style={{
                background: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)'
              }}
            >
              Continue to Pengi.ai →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
